module.exports = __webpack_public_path__ + "static/PHMT12-e368b3c3677f858c4dfb46d79d59a2c2.jpg";